module.exports = __webpack_public_path__ + "img/transport_category_3.34a78cde.svg";